(() => {
  document.addEventListener("alpine:init", () => {

    const BUNDLE_PROPS = {
      BUNDLE_INV_QTY: "_inventory_Quantity",
      BUNDLE_ID: "_bundle_id",
      BUNDLE_PARENT: "_bundle_parent",
      INCLUDED_WITH: "Included With",
      BUNDLE_ADDON: "_bundle_addon",
      BUNDLE_ITEM: "_bundle_item",
      BUNDLE_MULTIPLIER: "_bundle_multiplier",
      GIFT_BOX: "gift_box",
      GIFT_MSG: "Gift message",
      GIFT_OCCASION: "Occasion",
      GIFT_DATE: "When",
      GIFT_HIDE_CHESSHOUSE: "_Chess House on Packaging"
    }

    var _BVariants = []
    if (typeof _BProducts !== "undefined" && Array.isArray(_BProducts)) {
      _BVariants = _BProducts.map(p => p.variants).flat().filter(v => v !== undefined);
      _BVariants.forEach(v => {
        if (v.title == "Default Title") {
          v.title = v.name
        }
      }) 
    }
    Alpine.data("BundleProduct", () => ({
      main_qty: 1,
      cache: {},
      included: [],
      bundle_variants: [],
      current_tier: null,
      max_qty: null,
      flags: {
        is_soldout: false
      },
      init() {
        let am = this;
        am.InitSelf()

        am.$watch("included", am.SetSelectedVariants.bind(am))
      },
      InitSelf() {
        let am = this;

        am.cache.$product = am.$el.closest(".product")

        // Select all items in group when loaded
        am.$el.querySelectorAll(".included-items input").forEach(($input) => {
          $input.checked = true
          am.included.push($input.value)
        })
        am.SetSelectedVariants()
        
        am.$el.addEventListener("bundle--items-selected", () => {
          am.SetSelectedVariants()
          am.SetMaxQty()
        })

        // With quantity change, update quantities of all selected variants
        document.addEventListener("qty:changed", (e) => {
          // console.log(e)
          am.main_qty = e.detail.qty
          am.SetSelectedVariants()
        })

        // with gift msg changes
        document.addEventListener("gift_msg:changed", (e) => {
          // console.log(e)
          am.SetSelectedVariants()
        });

        // on variant change, update bundle parent variant
        document.addEventListener('variant:change', (e) => {
          // console.log(e);
          am.$el.querySelector('[data-_bundle_parent="true"]').value = e.detail.variant.id;
          am.SetSelectedVariants();
        });

        document.addEventListener("tier:changed", (e) => {
          // console.log(e.detail)
          am.current_tier = e.detail.current_tier;
        });
      },
      SetSelectedVariants() {
        let am = this;
        am.bundle_variants = []

        let $selected = am.$el.querySelectorAll("input:checked");
        $selected.forEach(($item) => {
          let variant_id = $item.value;
          let product_id = $item.dataset.product_id;
          let product = _BProducts.find(p => p.id == product_id);
          // console.log($item, variant_id, product_id, product)

          if (!product) return;
          let variant = product.variants.find(v => v.id == variant_id);
          if (!variant) return;

          let bundle_qty_multiplier = $item.dataset.item_qty || 1;
          variant.bundle_props = {
            _item_qty: bundle_qty_multiplier * am.main_qty,
          }
          let is_BundleParent = $item.dataset[BUNDLE_PROPS.BUNDLE_PARENT] == "true";
          let is_GiftBox = $item.dataset[BUNDLE_PROPS.GIFT_BOX] == "true";

          if (is_BundleParent) {
            variant.bundle_props[BUNDLE_PROPS.BUNDLE_PARENT] = JSON.stringify(is_BundleParent);
            am.flags.is_soldout = variant.available == false;
            // console.log("bundle-parent", $item, variant.bundle_props)
          }
          else {
            variant.bundle_props[BUNDLE_PROPS.INCLUDED_WITH] = am.$el.dataset.included_with;
            variant.bundle_props[BUNDLE_PROPS.BUNDLE_ITEM] = "bundle_item";
            variant.bundle_props[BUNDLE_PROPS.BUNDLE_MULTIPLIER] = bundle_qty_multiplier;
            variant.bundle_props[BUNDLE_PROPS.BUNDLE_ADDON] = $item.dataset.addon;
            // console.log("bundle-item", $item, variant.bundle_props)
          }

          if (is_GiftBox) {
            let $giftBox = $item.closest(".gift-box-content");
            variant.bundle_props[BUNDLE_PROPS.GIFT_MSG] = $giftBox.querySelector(`[name*="${ BUNDLE_PROPS.GIFT_MSG }"]`).value;
            variant.bundle_props[BUNDLE_PROPS.GIFT_OCCASION] = $giftBox.querySelector(`[name*="${ BUNDLE_PROPS.GIFT_OCCASION }"]`).value;
            variant.bundle_props[BUNDLE_PROPS.GIFT_DATE] = $giftBox.querySelector(`[name*="${ BUNDLE_PROPS.GIFT_DATE }"]`).value;
            variant.bundle_props[BUNDLE_PROPS.GIFT_HIDE_CHESSHOUSE] = $giftBox.querySelector(`[name*="${ BUNDLE_PROPS.GIFT_HIDE_CHESSHOUSE }"]`).checked ? "No" : "Yes";
            // console.log("bundle-gift", $item, variant.bundle_props)
          }
          // console.log($item, product, variant)

          if ($item.dataset.bundle_price) {
            variant.bundle_price = parseFloat($item.dataset.bundle_price);
          }
          if ($item.dataset.included_price) {
            variant.included_price = parseFloat($item.dataset.included_price);
          }

          am.bundle_variants.unshift(variant)
        });
      },
      SetMaxQty() {
        let am = this;
        // console.log(am.bundle_variants)
        let variants = am.bundle_variants.filter(v => v.bundle_props[BUNDLE_PROPS.BUNDLE_ADDON] == "false" && v.inventory_policy == "deny")
        // console.log(variants)
        variants.sort(v => v.inventory_quantity)
        let max_variant = variants[0];
        am.max_qty = max_variant && max_variant.inventory_quantity > 0 ? max_variant.inventory_quantity : null
        if (am.max_qty) {
          document.dispatchEvent(new CustomEvent("qty:set_max", {detail: {max_qty: am.max_qty}}))
        }
      },
      GetBundlePrice() {
        let am = this;
        let bundle_price = 0

        let parent_item = am.bundle_variants.find(v => v.bundle_props[BUNDLE_PROPS.BUNDLE_PARENT] == "true");
        bundle_price += parent_item.price * am.main_qty;

        let bundle_compare_price = bundle_price;
        if (!am.current_tier && parent_item.compare_at_price) {
          bundle_compare_price = parent_item.compare_at_price * am.main_qty;
        }

        // if tiered discounts
        if (am.current_tier) {
          let saved_amount = bundle_price * (am.current_tier.percent / 100);
          bundle_price = bundle_price - saved_amount;
        }
        // console.log({bundle_price, bundle_compare_price})

        let addons = am.bundle_variants.filter(v => ["true", "included"].indexOf(v.bundle_props[BUNDLE_PROPS.BUNDLE_ADDON]) !== -1);
        let addons_price = addons.reduce((sum, v) => {
          let addon_price = 0;
          // console.log(v)
          if (v.included_price) {
            addon_price = v.included_price;
          }
          if (v.bundle_price) {
            addon_price = v.bundle_price;
          }
          // console.log(addon_price)

          return sum + addon_price;
        }, 0) * am.main_qty;
        bundle_price += addons_price;
        bundle_compare_price += addons_price;

        // console.log(total_price, bundle_price)
        let bundle_price_format = s_utils.FormatMoney(bundle_price);
        let bundle_compare_price_format = s_utils.FormatMoney(bundle_compare_price);

        return {
          bundle_price,
          bundle_price_format,
          bundle_compare_price,
          bundle_compare_price_format         
        };
      },
      async e_AddBundleToCart(e) {
        let am = this;
        // console.log(e)

        let _bundle_id = s_utils.GetUniqId()
        
        
        if (am.bundle_variants.length == 0) return;
        let items_to_add = am.bundle_variants.map(variant => {
          let variant_props = variant.bundle_props
          variant_props[BUNDLE_PROPS.BUNDLE_ID] = _bundle_id
          variant_props[BUNDLE_PROPS.BUNDLE_INV_QTY] = variant.inventory_quantity
          return {
            id: variant.id,
            quantity: variant.bundle_props._item_qty,
            properties: variant_props
          };
        });
        // console.log(items_to_add)
        // debugger

        await s_utils.AddItemsToCart(items_to_add)
        s_utils.RefreshCart()
      },
      e_GiftMessageUpdate(e) {
        let am = this;
        am.SetSelectedVariants()
      }
    }));
  
    Alpine.data("BundleGroup", () => ({
      flags: {
        is_checkbox: false,
        is_optional: false
      },
      limit: 1,
      cache: {},
      selected: [],
      selected_variants: [],
      init() {
        let am = this;
        am.InitSelf()

        am.$watch("selected", am.SetSelectedVariants.bind(am))
      },
      InitSelf() {
        let am = this;
        am.cache.$group = am.$el
        am.cache.$bundle = am.$el.closest(".sc--bundle")

        am.limit = am.$el.dataset.limit || 1
        am.flags.is_checkbox = am.$el.dataset.is_checkbox == "true"
        am.flags.is_optional = am.$el.dataset.is_optional == "true"

        // Select items in group when loaded
        if (am.flags.is_optional && am.flags.is_checkbox) return;

        let $preselect_inputs = Array.from(am.cache.$group.querySelectorAll("input:not(.disabled)")).slice(0, am.limit)
        $preselect_inputs.forEach(($input) => {
          $input.checked = true
          $input.dispatchEvent(new Event("change", {bubbles: true}))
        })
        let preselect_values = $preselect_inputs.map($input => $input.value)

        am.selected = am.flags.is_checkbox ? preselect_values : preselect_values[0]
        am.SetSelectedVariants()
      },
      SetSelectedVariants() {
        let am = this;
        if (Array.isArray(am.selected)) {
          am.selected_variants = am.selected.map(variant_id => _BVariants.filter(variant => variant.id == variant_id)).flat()
        }
        else {
          am.selected_variants = _BVariants.filter(variant => variant.id == am.selected)
        }
        am.cache.$bundle.dispatchEvent(new CustomEvent("bundle--items-selected"))
      },
      e_LimitSelections(e, limit) {
        let am = this;
        if (Array.isArray(am.selected) && am.selected.length > limit) {
          // remove previous selected item
          am.selected.shift()
        }
      }
    }));

    Alpine.data("BundleCartItem", () => ({
      cart: null,
      bundle_parent_item: null,
      bundle_item_price: 0,
      bundle_item_price_format: "",
      bundle_items: [],
      bundle_addons: [],
      init() {
        let am = this;
        am.InitSelf()
      },
      InitSelf() {
        let am = this;
        let line_item_key = am.$el.dataset.line_item_key;
        (async() => {
          am.cart = await s_utils.GetCart()
          am.bundle_parent_item = am.cart.items.find(item => item.key == line_item_key)

          let bundle_id = am.bundle_parent_item.properties[BUNDLE_PROPS.BUNDLE_ID]
          let bundle_items = am.cart.items.filter(item => item.properties[BUNDLE_PROPS.BUNDLE_ID] == bundle_id)

          am.bundle_item_price = bundle_items.filter(item => {
            return item.properties[BUNDLE_PROPS.BUNDLE_PARENT] == "true" ||
              item.properties[BUNDLE_PROPS.BUNDLE_ADDON] == "true" ||
              item.properties[BUNDLE_PROPS.BUNDLE_ADDON] == "included"
          }).reduce((sum, item) => sum + item.final_line_price, 0)
          am.bundle_item_price_format = s_utils.FormatMoney(am.bundle_item_price)

          am.bundle_items = bundle_items;
          am.bundle_addons = bundle_items.filter(item => item.id !== am.bundle_parent_item.id);
        })()
      },
      async e_RemoveBundle(e) {
        let am = this;

        let updates = {};
        am.bundle_items.forEach((item) => {
          updates[item.key] = 0
        })
        // console.log(updates)

        if (JSON.stringify(updates) !== "{}") {
          await s_utils.UpdateCart(updates)
          s_utils.RefreshCart()
        }
      },
      async e_UpdateBundleQty (e) {
        let am = this;
        let updates = {};
        let new_qty = parseInt(e.target.value);
        am.bundle_items.forEach((item) => {
          if (item.properties[BUNDLE_PROPS.BUNDLE_PARENT] == "true") {
            updates[item.key] = new_qty
          }
          else {
            // console.log("multiplier:", item.properties[BUNDLE_PROPS.BUNDLE_MULTIPLIER])
            updates[item.key] = parseInt(item.properties[BUNDLE_PROPS.BUNDLE_MULTIPLIER]) * new_qty
          }
          // console.log(item, item.properties, updates[item.id])
        })
        // console.log(updates)

        if (JSON.stringify(updates) !== "{}") {
          await s_utils.UpdateCart(updates)
          s_utils.RefreshCart()
        }
      }      
    }));

    Alpine.data("ProductQty", () => ({
      cache: {},
      qty: 1,
      max_qty: null,
      current_tier: null,
      init() {
        let am = this;
        am.InitSelf();
        am.UpdateProductPrice();
        am.$watch('qty', am.UpdateProductPrice.bind(am));

        document.addEventListener("update:qty", (e) => {
          let new_qty = e.detail.qty
          if (am.qty !== new_qty) {
            am.cache.$qty.value = new_qty;
            am.cache.$qty.dispatchEvent(new Event("change", {bubbles: true}));
          }
        });

        document.addEventListener("qty:set_max", (e) => {
          am.max_qty = e.detail.max_qty;
        });

        // With tier change
        document.addEventListener("tier:changed", (e) => {
          // console.log(e.detail)
          am.current_tier = e.detail.current_tier;
          am.UpdateProductPrice();
        });

        // on variant change, update price display
        document.addEventListener('variant:change', (e) => {
          // console.log(e);
          am.$el.dataset.price = e.detail.variant.price;
          am.$el.dataset.compare_price = e.detail.variant.compare_at_price;
          am.UpdateProductPrice();
        });
      },
      InitSelf() {
        let am = this;
        am.cache.$qty = am.$el.querySelector("input[type=text]")
      },
      UpdateQty() {
      },
      e_OnQtyUpdate(e) {
        let am = this;
        am.qty = parseInt(am.cache.$qty.value)
        document.dispatchEvent(new CustomEvent("qty:changed", { detail: {qty: am.qty} }))
      },
      UpdateProductPrice() {
        let am = this;
        let $product = am.$el.closest('.product-info');
        let $price = $product.querySelector('.price-list');
        if (!$price) return;

        // hide theme badges
        $product.querySelector('.product-info__badge-list').classList.add('hidden');

        let percent = am.current_tier ? am.current_tier.percent : 0;

        let price = parseFloat(am.$el.dataset.price);
        let discounted_price = price * ((100 - percent) / 100);

        let compare_price = parseFloat(am.$el.dataset.compare_price);
        if (isNaN(compare_price)) {
          compare_price = price;
        }

        let savings = compare_price - discounted_price;
        // console.log({price, discounted_price, compare_price, savings})

        $price.innerHTML = `
          <span class="bundle-price text-lg">
            <span class="${ savings > 0 ? 'text-on-sale' : ''}">
              ${ s_utils.FormatMoney(discounted_price) }
            </span>
            ${
              savings > 0 ? `<small class="text-subdued line-through">${ s_utils.FormatMoney(compare_price) }</small>` : ""
            }
            ${
              savings > 0 ? `<span class="badge badge--on-sale">Save ${ s_utils.FormatMoney(savings) }</span>`: ""
            }
          </span>
        `;
      }
    }));

    Alpine.data("BundleDiscountsTable", (TAGS) => ({
      QTY_TIERS: [],
      price: "",
      current_tier: null,
      init() {
        let am = this;
        am.$watch("current_tier", () => {
          document.dispatchEvent(new CustomEvent("tier:changed", { detail: {current_tier: am.current_tier} }))
        })
        am.InitSelf()
      },
      InitSelf() {
        let am = this;
        am.price = parseFloat(am.$el.dataset.variant_price)

        let QTY_TIERS = TAGS.map(tag => {
          let qty = parseInt(tag.split("Discount")[0].replace("Tier", ""))
          let percent = parseInt(tag.split("Discount")[1])
          let saved = am.price * (percent / 100)
          let saved_formatted = s_utils.FormatMoney(saved)
          let new_price = am.price - saved
          let new_price_formatted = s_utils.FormatMoney(new_price)
          return {
            qty, 
            percent,
            saved,
            saved_formatted,
            new_price,
            new_price_formatted
          }
        })
        am.QTY_TIERS = QTY_TIERS.sort((a, b) => a.qty - b.qty)
        // console.log(am.QTY_TIERS)

        // on quantity change, select buttons
        document.addEventListener("qty:changed", (e) => {
          let qty = e.detail.qty
          let matching_tier = null
          am.QTY_TIERS.forEach(tier => {
            if (qty >= tier.qty) {
              matching_tier = tier
            }
          })
          am.current_tier = matching_tier

          // console.log(matching_tier)
          am.$el.querySelectorAll(".button").forEach(($btn) => {
            $btn.classList.add("button--subdued")
          })
          if (matching_tier) {
            am.$el.querySelector(`.button[data-qty="${ matching_tier.qty }"]`).classList.remove("button--subdued")
          }
        })
      },
      e_ApplyQty(e, qty) {
        e.stopImmediatePropagation()
        // console.log(qty)
        document.dispatchEvent(new CustomEvent("qty:changed", { detail: {qty} }));
        document.dispatchEvent(new CustomEvent("update:qty", { detail: {qty} }));
      }
    }));

    Alpine.data("PreOrder", () => ({
      cache: {},
      discount: 0,
      prop_name: "",
      init() {
        let am = this;
        am.InitSelf()
        am.CheckPreorder()
      },
      InitSelf() {
        let am = this;
        am.cache.$form = am.$el.closest(".shopify-product-form")
        am.cache.$btn_atc = am.cache.$form.querySelector("button[type=submit]")

        let tag = am.$el.dataset.tag
        am.discount  = tag.split("_")[1]
        am.prop_name = `properties[_Preorder${ am.discount }]`
      },
      CheckPreorder() {
        let am = this;
        am.cache.$form.classList.add("pre-order")
        let variant_price = am.$el.dataset.variant_price
        let amount_discount = variant_price * (am.discount / 100)
        let amount_discount_format = s_utils.FormatMoney(amount_discount)
        am.cache.$btn_atc.classList.remove("button--secondary")
        am.cache.$btn_atc.querySelector("div").innerHTML = `PAY NOW AND SAVE ${ amount_discount_format }`
      }
    }));

    // Remove orphaned items (if any)
    const RemoveBundleOrphanItems = async () => {
      let cart = await s_utils.GetCart()
      let orphaned_items = cart.items.map((item) => {
        let flag;
        let is_bundle = item.properties && item.properties[BUNDLE_PROPS.BUNDLE_ID]
        if (is_bundle) {
          let bundle_id = item.properties[BUNDLE_PROPS.BUNDLE_ID]
          let is_bundle_item = cart.items.find(item => item.properties && item.properties[BUNDLE_PROPS.BUNDLE_ITEM] == "bundle_item")
          if (is_bundle_item) {
            let has_bundle_parent = cart.items.filter(item => item.properties[BUNDLE_PROPS.BUNDLE_ID] == bundle_id && item.properties[BUNDLE_PROPS.BUNDLE_PARENT] == "true").length > 0
            flag = has_bundle_parent ? false : true
          }
        }
        else {
          flag = false
        }
        return flag ? item : false
      })
      orphaned_items = orphaned_items.filter(item => !!item)

      if (orphaned_items.length) {
        let updates = {};
        orphaned_items.forEach(item => {
          updates[item.key] = 0
        })

        if (JSON.stringify(updates) !== "{}") {
          await s_utils.UpdateCart(updates)
        }
      }
    }

    let cart_events = ["DOMContentLoaded", "cart:prepare-bundled-sections", "cart:refresh", "cart:change"]
    cart_events.forEach((cart_event) => {
      document.addEventListener(cart_event, RemoveBundleOrphanItems)  
    })
  })
})()
